<template>
  <div class="order-list tt-custom-tab">
    <div class="search-bar">
      <div>
        <el-select style="width:100%;" v-model="form.mix_param" clearable filterable :filter-method="filterSearchMixer"
          class="input-width" @change="search" placeholder="商家或发件人">
          <el-option v-for="item in mixOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-select :disabled="account_id==17852" style="width:100%;" v-model="form.receiver" clearable filterable :filter-method="filterSearchReceiver"
          class="input-width" @change="search" placeholder="收件人">
          <el-option v-for="item in receiverOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-select style="width:100%;" v-model="form.merchant_id" clearable filterable :filter-method="filterSearch"
          class="input-width" @change="search" placeholder="商家">
          <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <!--<div style="margin-left:20px;">
        <el-select style="width:140px" v-model="form.mail_theme" class="mobile-select" placeholder="邮件类型" @change="search">
          <el-option v-for="(status, index) in mailTypes" :key="index" :label="status.label"
            :value="status.name"></el-option>
        </el-select>
      </div>-->
      <div style="margin-left:20px;">
        <el-select style="width:140px" v-model="form.mail_theme" class="mobile-select" placeholder="邮件主题" @change="search">
          <el-option v-for="(status, index) in mailTypes" :key="index" :label="status.label"
            :value="status.name"></el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-select style="width:140px" v-model="form.status" class="mobile-select" placeholder="邮件状态" @change="search">
          <el-option v-for="(status, index) in mailStatusOptions" :key="index" :label="status.label"
            :value="status.name"></el-option>
        </el-select>
      </div>
    </div>
    <div class="search-bar seprator">
      <div style="display:flex;align-items:center;">
        <span>
            {{totalCount}}个邮件&nbsp;&nbsp;
        </span>
        <!--<el-button style="width:70px;" v-show="mailList.filter(i=>i.isSelected).length" :loading="multipleUpdating" class="block btn-14" type="info" @click="updateMultipleMail()">批量更新</el-button>-->
      </div>
      <div>
        <div style="display:inline-block;">
          <el-date-picker format="yyyy-MM-dd HH:mm" v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" @change="search">
          </el-date-picker>
        </div>
        <div style="display:inline-block;">
          <el-input class="commbo-input" style="width:500px;" clearable
            v-model="searchWord">
            <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择" style="width:120px;"
              >
              <!--<el-option label="全文搜索" value="0"></el-option>-->
              <el-option label="商家订单号" value="1"></el-option>
              <el-option label="商家物流号" value="2"></el-option>
              <el-option label="礼品卡号" value="3"></el-option>
            </el-select>
            <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
          </el-input>
        </div>
      </div>
    </div>
    <div class="table">
      <div class="table-head">
        <div style="width:70px;">
          <el-checkbox v-model="selectAll" @change="toggleSelect"></el-checkbox>
        </div>
        <div v-for="c in columns" :style="{width:c.width}">
          {{ c.name }}
        </div>
        <div style="opacity:0">
          <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="table-body pool">
          <el-collapse class="customCollapse2" v-model="activeName" accordion style="width:100%;" @change="changeCollapse">
            <el-collapse-item v-for="(r,index) in mailList" :name="index" :key="index">
              <template slot="title">
                <div class="table-row-title" style="line-height:1;width:100%;">
                  <div style="width:70px;">
                    <el-checkbox v-model="r.isSelected"></el-checkbox>
                  </div>
                  <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">
                      <i style="font-size: 20px;" class="el-icon-message"></i>
                  </div>
                  <div v-for="(c,idx) in columns" :key="idx" :style="{width:c.width}">
                    <template v-if="c.field=='send_time_display'">
                      <p style="font-size: 16px;padding-bottom: 5px;">{{ r.date_display }}</p>
                      <p style="color:#666;">{{ r.time_display }}</p>
                    </template>
                    <template v-if="c.field=='mail_content'">
                      <template v-if="r.mail_theme=='礼品卡'">
                        <p style="font-size: 16px;padding-bottom: 5px;">{{ `${r.merchant_display} #${r.merchant_order_number}` }}</p>
                        <p style="color:#666;">{{ `${r.mail_theme} ` }}<label v-if="r.price">{{ `${r.price_symbol}${r.price}${r.currency}` }}</label></p>
                      </template>
                      <template v-else-if="r.merchant_order_number">
                        <p style="font-size: 16px;padding-bottom: 5px;">{{ `${r.merchant_display} 订单#${r.merchant_order_number}` }}</p>
                        <p style="color:#666;">{{ `${r.mail_theme} ` }}<label v-if="r.tracking_number_display">{{ `#${r.tracking_number_display}` }}</label></p>
                      </template>
                      <template v-else>
                        <p style="font-size: 16px;padding-bottom: 5px;">{{ `${r.merchant_display} ${r.mail_theme}` }}</p>
                        <p style="color:#666;">{{ `${r.mail_subject} ` }}<label v-if="r.tracking_number_display">{{ `#${r.tracking_number_display}` }}</label></p>
                      </template>
                    </template>
                    <template v-if="c.field=='status_display'">
                      <p style="font-size: 16px;">{{ r[c.field] }}</p>
                    </template>
                  </div>
                </div>
              </template>
              <div class="table-row-content">
                <Mail :good_number="good_number" :r="r" :index="index" @updateMail="updateMail"></Mail>
                <div style="clear:both;"></div>
              </div>
              <div v-if="r.orders && r.orders.length" class="table-row-seperator"></div>
              <template v-if="r.orders && r.orders.length">
                <div>
                  <Order
                    :showHead="false"
                    :bussinessList="bussinessList"
                    :transportStatusArray="transportStatusArray"
                    :singleList="singleList"
                    :order="r.orders[r.order_index]"
                    :isSingle="true"
                    :expressList="expressList"
                    :delegates="delegates"
                    :supportAccountList="supportAccountList"
                    :supportEditAccountList="supportEditAccountList"
                    :addressList="addressList"
                    @refresh="updatePriceInfo">
                  </Order>
                </div>
              </template>
            </el-collapse-item>
          </el-collapse>
        </div>
    </div>
    <div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination :page-size="form.limit" :pager-count="5" :current-page.sync="form.page" layout="prev, pager, next"
        next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>

    <el-dialog v-if="modifySuccess" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="true" :visible.sync="modifySuccess" width="90%">
      <div class="text-center redirct">
        <p><i class="ico ico-paysucces completion"></i></p>
        <h1 style="padding: 60px 0 25px;">绑定成功</h1>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Order from '../list/Order'
import Mail from './MailBody.vue'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'OrderList',
  components: {
    Order:Order,
    Mail:Mail
  },
  data() {
    return {
      account_id:this.$localStorage.get('account_id'),
      multipleUpdating:false,
      activeName: '0',
      mailList: [],
      merchantOptions: [],
      merchants: [],
      columns: [
        { name: '发送时间', field: 'send_time_display',width:'160px' },
        { name: '邮件内容', field: 'mail_content',width:'calc(100% - 360px)' },
        /*{ name: '邮件类型', field: 'mail_theme',width:'100px' },
        { name: '商家', field: 'merchant_display',width:'200px' },
        { name: '订单号', field: 'merchant_order_number',width:'200px' },
        { name: '物流单号', field: 'tracking_number_display',width:'200px' },*/
        { name: '状态', field: 'status_display',width:'100px' },
      ],
      keyword_type: '2',
      searchWord: '',
      mailTypes: [],
      mailStatusOptions: [{name:'',label:'邮件状态'},{name:'1',label:'已处理'},{name:'2',label:'待处理'}],
      form:{
        limit:30,
        page:1,
        merchant_order_number:'',
        tracking_number:'',
        mail_theme:'',
        merchant_id:''
      },
      totalCount:0,
      timeRange:[],
      mailStatus:{'2':'待处理','1':'已处理','-1':'处理中...'},
      modifySuccess:false,
      selectAll:false,
      bussinessList:null,
      singleList: null,
      transportStatusArray:null,
      expressList:[],
      delegates:[],
      supportAccountList:[],
      supportEditAccountList:[],
      addressList:[],
      mailReceivers:[],
      receiverOptions:[],
      allSenders:[],
      allMerchant:[],
      mixOptions:[],
      good_number:0
    }
  },
  async mounted() {
    if(localStorage.getItem('mailList_timeRange'))
      this.timeRange=JSON.parse(localStorage.getItem('mailList_timeRange'))
    else{
      this.timeRange=[new Date(new Date().getTime()-3*24*3600*1000),new Date()]
    }
    if(localStorage.getItem('mailList_theme')){
      this.form.mail_theme=localStorage.getItem('mailList_theme');
    }
    await this.getMailThemes()
    await this.getMailReceiver()
    await this.getMixSender()
    await this.getOrdersMerchants()
    this.getGroupBussinessList()
    this.getSingleList()
    this.getTransportStatusArray()
    this.getAddressList()
    api.getExpressList(this,'').then((res)=>{
        this.expressList=res.body.result;
    })
    api.getShipDelegateList(this).then((res)=>{
      this.delegates=res.body.result;
    })
    api.getSupportAccountList(this).then((res)=>{
      this.supportAccountList=res.body.result;
    })
    api.getEditSupportAccountList(this).then((res)=>{
      this.supportEditAccountList=res.body.result;
    })
    this.search()
  },
  methods: {
    updatePriceInfo(data){
      data.order.price_info=data.price_info;
    },
    async getAddressList(){
      let res = await api.getAddressList(this)
      res = res.body
      this.addressList = res.result
    },
    async getTransportStatusArray () {
      let res = await api.getTransportStatusArray(this)
      this.transportStatusArray=[{id:-1, show:'预报状态'}]
      for(let p in res.body.result){
        res.body.result[p].forEach((i)=>{
          this.transportStatusArray.push({id:i.id,show:i.show,nextStep:i.nextStep,type:p})
        })
      }
    },
    async getSingleList () {
      let res = await api.getSingleList(this)
      this.singleList=res.body.result
    },
    async getGroupBussinessList () {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
    },

    async changeCollapse(data){
        if(data===''){
            return
        }
      let mail=this.mailList[data]
        if(mail&&mail.mail_type==5&&!mail.content_info){
            //加载content
        let temp=  await  api.getMailContent(this,{mail_id:mail.mail_id});
            let content = temp.body.result
            mail.content_info=content.content_info
        }
      if(mail.orders)
        return
      let params={}
      if(mail.merchant_id!='0')
        params.merchant_id=mail.merchant_id
      params.keyword_type=2
      params.keyword=mail.merchant_order_number
      params.page=1
      params.limit=1
        if(!mail.merchant_order_number){
            //fix-推广邮件
            return
        }
      let res = await api.getSingleOrders(this, params)
      mail.orders = res.body.result
      mail.order_index=0
      if(mail.orders.length==1){
        let r=await api.bindingMailTask(this,{mail_id:mail.id,task_ids:[mail.orders[0].id]})
        if(r.body.status=='ok'){
          mail.mail_task_relation=[mail.orders[0].id]
        }
        //满足条件的邮件自动更新为已处理
        if(mail.mail_theme=='订单发货' && mail.status=='2'){
          let nums=mail.tracking_list;
          let allReady=true
          nums.forEach((n)=>{
            if(mail.orders[0].shipping_info.map((o)=>{return o.AWB}).indexOf(n)==-1)
              allReady=false
          })
          if(allReady){
            //mail.status='-1'
            mail.status_display=this.mailStatus[mail.status]
            /*let r=await api.updateMailInfo(this,{id_list:[mail.id],status:1})
            if(r.body.status=='ok'){
              mail.status='1'
              mail.status_display=this.mailStatus[mail.status]
            }*/
          }
        }
      }
      mail.orders.forEach((o)=>{
        o.order_grouplines=_.groupBy(o.goods_list, 'package_id')
        for(let p in o.order_grouplines){
          this.getshippinginfo(o.order_grouplines[p],o)
        }
      })
      this.$set(this.mailList[data],0,mail)
      //this.mailList[data]=mail;
      this.$forceUpdate()
    },
    getshippinginfo (groupOrderLine,order) {
      if(groupOrderLine[0].shipping_id){
        _.each(order.shipping_info,item => {
            if(groupOrderLine[0].shipping_id == item.id){
                if(item.terminal_store_number) {
                  groupOrderLine.shipping_number = item.terminal_store_number
                  groupOrderLine.title = "终端物流"
                }
                if(item.transport_store_number && !item.terminal_store_number){
                  groupOrderLine.shipping_number = item.transport_store_number
                  groupOrderLine.title = "转运物流"
                }
                if(!item.transport_store_number && !item.terminal_store_number){
                  groupOrderLine.shipping_number = item.AWB
                  groupOrderLine.title = "商家物流"
                }
            }
        })
      }
    },
    search(){
      const generateParams=()=>{
        let params={}
        params.limit=this.form.limit;
        params.page=this.form.page;
        for(let p in this.form){
          if(this.form[p])
            params[p]=this.form[p]
        }
        if(this.timeRange.length){
          params.start_time=this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
          params.end_time=this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
            localStorage.setItem('mailList_timeRange',JSON.stringify(this.timeRange))
        }
        localStorage.setItem('mailList_theme',this.form.mail_theme)
        if(this.searchWord){
          switch(this.keyword_type){
            case '1':
              params.merchant_order_number=this.searchWord;
              break;
            case '2':
              params.tracking_number=this.searchWord;
              break;
            case '3':
              params.gift_card_number=this.searchWord;
              break;
          }
        }
        return params
      }
      let params=generateParams()
      this.getList(params)
    },
    toggleSelect(){
      this.mailList.forEach((m)=>{
          m.isSelected=this.selectAll
      })
    },
    async updateMultipleMail(){
      this.multipleUpdating=true
      let arr=this.mailList.filter(i=>i.isSelected).map(i=i.id)
      let res=await api.updateMailInfo(this,{id_list:arr,status:1})
      if(res.body.status=='ok'){
        mail.status='1'
      }
      this.multipleUpdating=false
    },
    async updateMail(index){
      let mail = this.mailList[index]
      mail.updating=true
      let res=await api.updateMailInfo(this,{id_list:[mail.id],status:mail.status})
      if(res.body.status!='ok'){
        mail.status=mail.status=='1'?'2':'1'
      }
      mail.updating=false
      mail.status_display=this.mailStatus[mail.status]
      this.mailList[index]=Object.assign({},mail)
      this.$forceUpdate()
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    getList(params) {
      api.getMailList(this, params).then((res) => {
        this.mailList = res.body.rows;
        this.mailList.forEach((i)=>{
          i.status_display=this.mailStatus[i.status]
          if(i.merchant_id!='0' && this.merchants.filter(j=>j.merchant_id==i.merchant_id).length)
            i.merchant_display=this.merchants.filter(j=>j.merchant_id==i.merchant_id)[0].merchant_name
          else
            i.merchant_display=i.sender
          if(i.send_time){
            i.date_display=this.generateDateDisplay(i.send_time.split(' ')[0])
            i.time_display=i.send_time.split(' ')[1]
          }
          if(i.tracking_list && i.tracking_list.length){
            i.tracking_number_display=i.tracking_list.map(j=>j?j.tracking_number:'').join(',')
          }
          if(i.package_content){
            if(i.package_content.confirm){
              i.package_content.confirm.forEach((g)=>{
                if(g.spec){
                  g.good_detail_arr=JSON.parse(g.spec)
                }
              })
              i.good_number=i.package_content.confirm.length
            }
            if(i.package_content.out_of_stock){
              i.package_content.out_of_stock.forEach((g)=>{
                if(g.spec){
                  g.good_detail_arr=JSON.parse(g.spec)
                }
              })
              i.good_number=i.package_content.out_of_stock.length
            }
            if(i.package_content.shipping_now && i.package_content.shipping_now.length){
              i.package_content.shipping_now.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec){
                    g.good_detail_arr=JSON.parse(g.spec)
                  }
                })
                i.good_number=i.good_number+s.good_list.length
              })
            }
            if(i.package_content.already_shipped && i.package_content.already_shipped.length){
              i.package_content.already_shipped.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec){
                    g.good_detail_arr=JSON.parse(g.spec)
                  }
                })
                i.good_number=i.good_number+s.good_list.length
              })
            }
            if(i.package_content.finished && i.package_content.finished.length){
              i.package_content.finished.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec){
                    g.good_detail_arr=JSON.parse(g.spec)
                    i.good_number=g.good_detail_arr.length
                  }
                })
                i.good_number=i.good_number+s.good_list.length
              })
            }
            if(i.package_content.arrive_soon && i.package_content.arrive_soon.length){
              i.package_content.arrive_soon.forEach((s)=>{
                s.good_list.forEach((g)=>{
                  if(g.spec){
                    g.good_detail_arr=JSON.parse(g.spec)
                    i.good_number=g.good_detail_arr.length
                  }
                })
                i.good_number=i.good_number+s.good_list.length
              })
            }
            if(i.package_content.shipping_soon && i.package_content.shipping_soon.length){
              i.package_content.shipping_soon.forEach((g)=>{
                if(g.spec){
                  g.good_detail_arr=JSON.parse(g.spec)
                }
              })
              i.good_number=i.package_content.shipping_soon.length
            }
            if(i.package_content.cancel){
              i.package_content.cancel.forEach((g)=>{
                if(g.spec){
                  g.good_detail_arr=JSON.parse(g.spec)
                }
              })
              i.good_number=i.package_content.cancel.length
            }
          }
        })
        this.totalCount=+res.body.total;
      })
    },
    async getMailThemes(){
      let res = await api.getMailThemes(this)
      res = res.body
      let types = res.result
      this.mailTypes = [{name:'',label:'邮件主题'}]
      types.forEach(item => {
        this.mailTypes.push({ name: item,label: item })
      })

    },
    async getMailReceiver(){
      let res = await api.getMailReceiver(this)
      res = res.body
      let types = res.result
      if(this.account_id==17852){
        this.form.receiver='joyorders@hotmail.com'
      }
      else{
        this.mailReceivers = [{name:'',label:'收件人'}]
        types.forEach(item => {
          this.mailReceivers.push({ name: item,label: item })
        })
      }

    },
    async getMixSender(){
      let res = await api.getMixSender(this)
      res = res.body
      this.allSenders = res.result.sender
      this.allMerchant = res.result.business
      //this.mailSender = [{name:'',label:'商家或发件人'}]

    },
    async getOrdersMerchants() {
      let res = await api.getOrdersMerchants(this, {})
      res = res.body
      this.merchants = res.result
      this.merchantOptions = []
      this.merchants.forEach(item => {
        this.merchantOptions.push({ value: item.merchant_name, id: item.merchant_id })
      })
    },
    filterSearchMixer(val){
      this.mixOptions = []
      let mers = [];
      if (val) {
        if(val.indexOf('@')>-1){
          mers = this.allSenders.filter((item) => {
            return item.toLowerCase().indexOf(val.toLowerCase()) > -1
          })
          mers.forEach(item => {
            this.mixOptions.push({ value: item, id: item })
          })
        }
        else{
          mers = this.allMerchant.filter((item) => {
            return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1
          })
          mers.forEach(item => {
            this.mixOptions.push({ value: item.name, id: item.id })
          })
        }
      }
      else {
        mers = [];
      }
      console.log('test',mers)
    },
    filterSearchReceiver(val) {
      this.receiverOptions = []
      let mers = [];
      if (val) {
        mers = this.mailReceivers.filter((item) => {
          return item.label.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
      else {
        mers = this.mailReceivers;
      }
      mers.forEach(item => {
        this.receiverOptions.push({ value: item.label, id: item.name })
      })
    },
    filterSearch(val) {
      this.merchantOptions = []
      let mers = [];
      if (val) {
        mers = this.merchants.filter((item) => {
          return item.merchant_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
      else {
        mers = this.merchants;
      }
      mers.forEach(item => {
        this.merchantOptions.push({ value: item.merchant_name, id: item.merchant_id })
      })
    },
    async querySearch(queryString, cb) {
      let arr = []
      let mers = [];
      if (queryString) {
        mers = this.merchants.filter((item) => {
          return item.merchant_name.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        })
      }
      else {
        mers = this.merchants;
      }
      mers.forEach(item => {
        arr.push({ value: item.merchant_name, id: item.merchant_id })
      })
      cb(arr)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.empty-content {
  padding: 50px 0 50px;
}
</style>

<style lang="scss">
.order-list {
  margin-bottom: 80px;

  .el-tabs__content {
    overflow: visible;
  }
}

.search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom:10px;
  &.seprator{
    justify-content: space-between;
  }
}
.table{
  margin-top:43px;
  overflow-x:auto;
  overflow-y:hidden;
  .table-head,
  .table-body{
    display: flex;
  }
  .table-head{
    padding: 18px 11px 18px 21px;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
  }
  .table-row-title{
    display: flex;
  }
  .table-head{
    color:#888888;
  }
  .seporater-order{
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top:none;
      line-height: 40px;
    }
  .table-row-content{
    //display:flex;
    padding:25px 50px 30px;
    border: 1px solid #D7D7D7;
    border-top:none;
    &.order{
      display:block;
      border-top: 1px solid #D7D7D7;
    }
  }
  .table-row-seperator{
    float: left;
    height: 33px;
    width: 100%;
    border-left: 1pX dashed #D7D7D7;
    border-right: 1px dashed #D7D7D7;
  }
}
.yd-pagination{
  margin-top:30px;
}
.redirct {
    font-size:24px;
    line-height:33px;
    margin-top: 54px;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }
  .product-price label.danger{
    font-size: 18px;
    color:#FF4650;
  }

</style>



// WEBPACK FOOTER //
// src/pages/orders/mail/list.vue